import {handleResponse} from "@/services/service-helpers.ts";

const NBH_APP_INFO_URL = `${import.meta.env.VITE_NBH_URL_ROOT}/api/info`;

export interface AppInfo {
    version: string;
    environment: string;
    buildTime: string;
}

export async function fetchAppInfo(token: string): Promise<AppInfo> {
    const response = await fetch(NBH_APP_INFO_URL, {
        method: 'GET',
        headers: new Headers({
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        })
    });

    return await handleResponse<AppInfo>(response) as AppInfo;
}
